module.exports = __webpack_public_path__ + "img/14.f3d719bd.jpg";